export const routes = {
  login: '/login',
  loginVerifyOtp: '/login/verify-otp',
  forgotPassword: '/forgot-password',
  forgotVerify: '/forgot-password/verify',
  forgotReset: '/forgot-password/reset',

  dashboard: '/',

  orders: '/orders',
  order: (id = ':id') => `/orders/${id}`,
  orderEdit: (id = ':id') => `/orders/${id}/edit`,

  customers: '/customers',
  customersNew: '/customers/new',
  customer: (id = ':id') => `/customers/${id}`,
  customerEdit: (id = ':id') => `/customers/${id}/edit`,

  products: '/products',
  productEdit: (id = ':id') => `/products/${id}/edit`,
  bundles: '/products/bundles',
  productsBundlesNew: '/products/bundles/new',
  productsBundlesEdit: (id = ':id') => `/products/bundles/${id}/edit`,
  // products hub tabs
  productsDevices: '/products/devices',
  productsComponents: '/products/components',
  productsComponentsNew: '/products/components/new',
  productsComponentsEdit: (id = ':id') => `/products/components/${id}/edit`,
  productsDevicesNew: '/products/devices/new',
  productsDevicesEdit: (id = ':id') => `/products/devices/${id}/edit`,
  productsCategory: '/products/category',

  installations: '/installations',
  installation: (id = ':id') => `/installations/${id}`,

  // request hub
  requests: '/requests',
  requestsInstallation: '/requests/installation',
  requestsReplacement: '/requests/replacement',
  requestsWarranty: '/requests/warranty',

  devices: '/devices',
  device: (id = ':id') => `/devices/${id}`,

  support: '/support',
  ticket: (id = ':id') => `/support/${id}`,
  // support ticket hub tabs
  supportOrders: '/support/orders',
  supportDevices: '/support/devices',

  subscriptions: '/subscriptions',
  payments: '/payments',

  reports: '/reports',
  reportOrders: '/reports/orders',
  reportDeviceCount: '/reports/device-count',
  reportDeviceActivity: '/reports/device-activity',
  reportCustomerUsage: '/reports/customer-usage',
  reportSubscription: '/reports/subscription',

  notifications: '/notifications',
  activityLog: '/activity-log',

  configurations: '/configurations',
  configTax: '/configurations/tax',
  configDiscounts: '/configurations/discounts',
  configDiscountsNew: '/configurations/discounts/new',
  configDiscount: (id = ':id') => `/configurations/discounts/${id}`,
  configDiscountEdit: (id = ':id') => `/configurations/discounts/${id}/edit`,
  configInstallationFees: '/configurations/installation-fees',
  configWarrantyPeriods: '/configurations/warranty-periods',

  adminUsers: '/admin-users',
  // internal users hub tabs
  adminUsersInternal: '/admin-users/internal',
  adminUsersDealers: '/admin-users/dealers',

  notFound: '/404',
  serverError: '/500',
} as const;
